import { render, staticRenderFns } from "./TodoCard.vue?vue&type=template&id=2e5eed0e&"
import script from "./TodoCard.vue?vue&type=script&lang=js&"
export * from "./TodoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports